export const IscAbout_2023 = [
  {
    id: 0,
    title: 'ISC互联网安全大会介绍',
    title_small: '第十一届互联网安全大会',
    desc: 'ISC是亚太地区乃至当今世界规格高、辐射广、影响力深远的全球性安全峰会。自2013年举办首届以来，ISC十年间举办超20场国际峰会，设立超600场分论坛，输出超4500个行业前沿议题，吸引来自中国、美国、俄罗斯、以色列、德国等全球30多个国家的2000余位政要、行业领袖、安全专家深度参与，共话前瞻安全观点和发展趋势，成为中国网络安全产业的风向标。2022年，ISC 2022携手GDEC全球数字经济大会成功打造全球首场数字安全峰会，创下2613万人次在线观看的空前记录。',
    list: [
      {
        id: 0,
        title: '规格顶尖：',
        desc: '国内首个国家级数字安全大会，打造集全球前瞻对话、高峰技术研讨、安全成果展示于一体的数字安全盛宴。'
      },
      {
        id: 1,
        title: '十年引领：',
        desc: '十年紧扣时代命脉，持续为行业提供纵深沉淀的技术导向和战略引领，向全球传递中国网安声音。'
      },
      {
        id: 2,
        title: '万人齐聚：',
        desc: '线下累计超15万专业观众参会，全面覆盖金融、能源、制造、医疗、军工、教育、交通、安全厂商等多个领域；线上曝光量超8亿，全渠道同频共振发声'
      }
    ],
    pic: 'https://p3.ssl.qhimg.com/t015cf99acc3f072a1f.jpg'
  },
  {
    id: 1,
    title: 'ISC主题论坛介绍',
    title_small: '第十一届互联网安全大会',
    desc: 'ISC汇聚全球行业尖端人物，围绕数字经济前瞻政策、全球数字化转型之下的数字空间治理等顶层话题，关注人工智能安全、高级威胁情报等前瞻技术方向，以及数字安全产业蓝海等热点内容，开设超600场行业及技术主题论坛，十年间累计输出紧贴国家、经济、社会、企业的行业前沿议题超4500个。',
    list: [
      {
        id: 0,
        title: '内容专精：',
        desc: '从政策解读、技术分析、行业案例、产业发展等多个维度解读数字安全，搭建安全从业人员知识分享与技术交流的平台。'
      },
      {
        id: 1,
        title: '行业智库：',
        desc: '联合2000+国内外政要、行业领袖及数字安全专家，打造数字安全智库，推动国家间数字安全交流，探索国际安全技术与趋势，助力国家安全产业发展。'
      },
      {
        id: 2,
        title: '成果丰富：',
        desc: '安全知识永久留存，打造中国唯一的安全视频维基百科，搭建产学研线上交流平台。'
      }
    ],
    pic: 'https://p1.ssl.qhimg.com/t0198cd1aee48302076.jpg'
  },
  {
    id: 2,
    title: 'ISC特色展区介绍',
    title_small: '第十一届互联网安全大会',
    desc: 'ISC展厅是聚拢行业最新研究成果和创新产品的窗口，汇聚安全厂商、科技巨头、联盟协会、专业媒体等，以规模、形式、内容上的升级与创新，不断向全球展示数字时代下安全领域的新技术、新产品、新应用，助力各行各业实现数字化转型，共赢数字安全新未来。',
    list: [
      {
        id: 0,
        title: '展商众多：',
        desc: '全面覆盖600+各行业头部企业，实现行业上下游产业链的互联互通，以行业平台优势引领数字安全产业，构建生态新格局。'
      },
      {
        id: 1,
        title: '形式多样：',
        desc: '配合中小企业需求，为新品发布、项目路演、投资合作、商务洽谈、技术分享等多样化场景打造不同定制化的展示方式，成功支持超500项创新成果发布。'
      },
      {
        id: 2,
        title: '观众海量：',
        desc: '通过3D建模、视频播放等多种手段，为观众带来立体式、沉浸式的观感体验，开创了日均参会人数7000+的纪录。'
      }
    ],
    pic: 'https://p1.ssl.qhimg.com/t01668d02d99ad3d01e.png'
  }
]
export const IscSchedule_2023 = {
  bgc: 'https://p5.ssl.qhimg.com/t0176d96a9af90b5feb.png',
  title: '大会日程',
  desc: 'CONGRESS AGENDA',
  data: [
    {
      date: '2023-08-09',
      title: '战略 产业',
      default: 1,
      list: [
        {
          time: '13:00-15:30',
          title: '保险数字安全论坛',
          link: 'https://isc.360.com/2020/detail.html?vid=4494'
        },
        {
          time: '13:00-15:30',
          title: '第五届智慧能源网络安全论坛',
          link: 'https://isc.360.com/2020/detail.html?vid=4494'
        },
        {
          time: '13:00-15:30',
          title: '金融业网络和数据安全论坛',
          link: 'https://isc.360.com/2020/detail.html?vid=4494'
        }
      ]
    },
    {
      date: '2023-08-10',
      title: '技术',
      default: 0,
      list: [
        {
          time: '13:00-15:30',
          title: '数宇安全国际合作论坛 暨第八届观潮网络空间论坛',
          link: 'https://isc.360.com/2020/detail.html?vid=4494'
        },
        {
          time: '13:00-15:30',
          title: '第五届智慧能源网络安全论坛',
          link: 'https://isc.360.com/2020/detail.html?vid=4494'
        },
        {
          time: '13:00-15:30',
          title: '金融业网络和数据安全论坛',
          link: 'https://isc.360.com/2020/detail.html?vid=4494'
        }
      ]
    },
    {
      date: '2023-08-11',
      title: '闭幕式',
      default: 0,
      list: [
        {
          time: '13:00-15:30',
          title: '网安产业投资生态论坛',
          link: 'https://isc.360.com/2020/detail.html?vid=4494'
        },
        {
          time: '13:00-15:30',
          title: '第五届智慧能源网络安全论坛',
          link: 'https://isc.360.com/2020/detail.html?vid=4494'
        },
        {
          time: '13:00-15:30',
          title: '金融业网络和数据安全论坛',
          link: 'https://isc.360.com/2020/detail.html?vid=4494'
        }
      ]
    }
  ]
}
export const IscActive_2023 = [
  {
    id: 0,
    pic: 'https://p2.ssl.qhimg.com/t0149bcd4c76b867b4f.jpg',
    title: '火热抢票中',
    desc_title: 'ISC 2023火热抢票中！立即抢票享优惠！',
    desc_nav:
      'ISC 2023第十一届互联网安全大会将于8月9日至10日在北京国家会议中心召开，8月11日开启ISC线上数字小镇，买VVIP票送环球影城全年畅玩！立即抢票锁定年度安全盛宴！',
    moreUrl: 'https://isc.360.com/new/2023/618.html'
  },
  {
    id: 1,
    pic: 'https://p0.ssl.qhimg.com/t018e3b2a4a173726be.jpg',
    title: '早鸟招商',
    desc_title: '锁定ISC 2023早鸟招商权益，享多项专属福利！',
    desc_nav:
      'ISC 2023 第十一届互联网安全大会将于 8 月在北京·国家会议中心举行，现已正式开启早鸟招商通道，超值特惠限时放送诚邀您在此展示数字经济时代下数字安全产业的新技术、新产品、新成果、新应用。届时，我们将与现场数千位全球顶级智库专家学者、技术从业者、行业客户以及全球千万名线上观众共司见证产业发展成果，探索行业风向，共筑数字安全生态。',
    moreUrl: 'https://isc.360.com/new/2023/membership.html'
  },
  {
    id: 2,
    pic: 'https://p2.ssl.qhimg.com/t01db7b258e96d7dd3e.jpg',
    title: '创新独角兽沙盒大赛',
    desc_title: 'ISC 2023创新独角兽沙盒大赛招募正式开启！',
    desc_nav:
      '面对数字时代下的全新安全命题，本届大赛秉承“聚合新生力，拓界新安全共竞新巅峰”携手知名安全分析机构，行业内权威专家评审，客户智库以及全球主流媒体，共同搭建起多领域、多层次、多维度的数字安全创新企业竞演空间，持续为中国数字安全的创新脉动赋能，助力推动全球布局下数字安全的高质量发展。',
    moreUrl: 'https://isc.360.com/new/2023/sandbox2.html'
  },
  {
    id: 3,
    pic: 'https://p5.ssl.qhimg.com/t0143a8332a8426e97b.jpg',
    title: '全球议题征集',
    desc_title: 'ISC 2023全球议题征集启动，寻找1000名Speaker and Listener',
    desc_nav:
      '为唤醒行业发声的主动权，ISC 2023 全球议题征集从“听”和说”双视角拓展，旨在为演讲者(Speaker)提供更专业化的发声窗口，为听众(Listener)提供真正想听的安全内容。大会将在全球范围寻找1000 名优质 Speaker and Listener,开启“议题风暴”模式共创一场顶级安全盛筵。',
    moreUrl: 'https://isc.360.com/new/2023/topic.html'
  },
  {
    id: 4,
    pic: 'https://p3.ssl.qhimg.com/t017e2c424a253b5b81.jpg',
    title: '挑战吉尼斯',
    desc_title: '全球共书新安全！ISC 2023邀你共同创造吉尼斯世界纪录荣誉',
    desc_nav:
      'ISC向全球战略决策者、专家智囊、行业领袖以及所有关注ISC的朋友们发出邀请，在6月30日12:30-13:30期间，写下对ISC 2023议题的想法与期待，向议题最多的行业顶会荣誉发起冲击，共同创造专属于数字安全的吉尼斯世界纪录荣誉！',
    moreUrl: 'https://isc.360.com/new/2023/guinness.html'
  }
]
export const IscReview_2023 = [
  {
    id: 0,
    pic: 'https://p0.qhimg.com/dm/686_382_/t01c6744d0b09bb172a.jpg',
    title: '第十届互联网安全大会',
    desc: 'ISC 2022以“护航数字文明，开创数字安全新时代”为主题，携手GDEC举办2022全球数字经济大会-数字安全峰会，运用2D与3D相结合的创新模式，打造了首个国家级元宇宙会议，创下了10亿全网曝光、2613万人次在线观看的空前记录，呈现出千位专家参会百家企业参展的大会盛况。',
    time: '2022.7.30'
  },
  {
    id: 1,
    pic: 'https://p0.qhimg.com/dml/686_382_/t018e40785d78aeeae8.jpg',
    title: '第九届互联网安全大会',
    desc: 'ISC 2021以“网络安全需要新战法，网络安全需要新框架”为主题，共举办9场高峰会、30余场分论坛。来自中国、俄罗斯、法国等多个国家的院士、全球顶级专家智囊、研究学者、行业领袖，共话全球数字化转型。参会人数超4万人次，微博话题破2.5亿，规模创下当年新高。',
    time: '2021.7.27'
  },
  {
    id: 2,
    pic: 'https://p2.ssl.qhimg.com/t0128faa87e688f627c.jpg',
    title: '第八届互联网安全大会',
    desc: 'ISC 2020传承自ISC大会八年来的深厚积累，ISC平台应运而生。ISC平台由中国互联网协会、中国网络空间安全协会、全国工商联大数据运维（网络安全）委员会、中国计算机协会、公安部第三研究所、360互联网安全中心等机构大力支持，并以网安企业的赋能者、网安行业的传承者、网安产业的引领者、网安文化的传播者为目标，旨在打造融合技术交流、媒体社交、流量输出、网安学院、行业服务等多重属性的“创新孵化平台”。',
    time: '2020.8.5'
  },
  {
    id: 3,
    pic: 'https://p3.ssl.qhimg.com/t019028c11f8000db3b.png',
    title: '第七届互联网安全大会',
    desc: 'ISC 2019以“应对网络战、共建大生态、同筑大安全”为主题，吸引了近百家网络安全企业参展，带来了在网络安全多个细分领域的最新研究成果。大会期间举办20多场技术分论坛，探讨网络安全领域的多个重点议题，包括行业政策与法规，工业互联网安全、城市安全、5G安全、漏洞挖掘、网络安全人才培养等等，探讨网络战时代的安全挑战与应对之道。',
    time: '2019.8.19'
  },
  {
    id: 4,
    pic: 'https://p2.ssl.qhimg.com/t01d067304fcb055391.png',
    title: '第六届互联网安全大会',
    desc: 'ISC 2018 以“安全从0开始”为主题，共话数字化时代网络安全问题。3天，3大主题日，3场峰会，33场分论坛，国内主管机构、安全企业、创客学者、网络安全届泰斗、全球安全领域专家深入解读“大安全时代”，探讨了数字化转型时代的网络安全挑战与应对。',
    time: '2018.9.14'
  },
  {
    id: 5,
    pic: 'https://p1.ssl.qhimg.com/t012e6ffa9e16b1df08.png',
    title: '第五届互联网安全大会',
    desc: 'ISC 2017以“万物皆变，人是安全的尺度”为主题，探讨人与互联安全的耦合作用。如今已经进入大安全时代，一味地堆砌设备，重金打造的防线看似固若金汤，实际上不堪一击，因为安全不仅仅是技术问题，更是人的问题。人是安全的尺度，借助人类思想的交互、观点的碰撞、实践的交流，可以为网络安全带来更新鲜的启发。',
    time: '2017.9.12'
  },
  {
    id: 6,
    pic: 'https://p0.ssl.qhimg.com/t01a176f928889f8864.png',
    title: '第四届互联网安全大会',
    desc: 'ISC 2016以“协同联动共建安全+命运共同体”为主题，致力推进互联网行业数据协同、产业协同和智能协同。大会还对国家网络空间战略、产业政策及法规、网络安全技术、投资与创业、人才培养等热点安全话题进行了深度讨论。与会者得到共识，只有协同联动，才能打破数据孤岛，让全球互联安全成为可能。',
    time: '2016.8.16'
  },
  {
    id: 7,
    pic: 'https://p4.ssl.qhimg.com/t019dadc58f21617336.png',
    title: '第三届互联网安全大会',
    desc: 'ISC 2015 以“数据驱动安全”为主题，深入探讨全球信息安全最新发展趋势，分享前沿安全技术研究成果及实践。大会聚焦网络安全的“雷达侦测”能力及“数据共享”。更广域的网络空间覆盖对网络安全防护提出了更高的要求。为此360建立了国内首个威胁情报中心，以应对日渐紧迫与复杂的网络安全局势',
    time: '2015.9.28'
  },
  {
    id: 8,
    pic: 'https://p5.ssl.qhimg.com/t01e915a0858861f5cc.png',
    title: '第二届互联网安全大会',
    desc: 'ISC 2014 以“互联世界，安全第一”为主题，聚焦互联网时代、大数据背景下信息安全所面临的全新挑战与问题。国家网络空间战略、智慧城市、互联网金融、数字医疗、可穿戴计算等前瞻命题在大会现场被深刻讨论。',
    time: '2014.9.24'
  },
  {
    id: 9,
    pic: 'https://p4.ssl.qhimg.com/t01c0384b9a733aa895.png',
    title: '第一届互联网安全大会',
    desc: 'ISC 2013涵盖互联网安全主题会议、专业技术论坛、商务洽谈会、解决方案与产品展览、网络攻防赛等多样形式。本次大会还特设移动安全论坛，邀请到来自三星、360、PCSL等顶级手机厂商以及安全厂商的专家，深入探讨移动安全的现状与未来，并首次公开了多项研究成果。',
    time: '2013.9.23'
  }
]
